import { Text, Center, Image, Box } from "@chakra-ui/react";
import image1 from "../images/supportedPlatforms.jpg";

export default function SupportedPlatforms(props) {
  return (
    <div {...props} style={{ paddingTop: "80px" }}>
      <Box mt='1px'>
        <Center>
          <Text
            color='white'
            fontSize={{ base: "xl", md: "2xl", lg: "4xl" }}
            fontWeight={700}
            mb={5}
          >
            Supported Platforms
          </Text>
        </Center>
        <Center>
          <Image
            src={image1}
            alt='supported-platforms image'
            width={{ base: "90%", md: "77%", lg: "77%" }}
            borderRadius={3}
          />
        </Center>
      </Box>
    </div>
  );
}
